var _defs, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path4, _path5, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon, _polygon2, _path25, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _rect, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect2, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _circle, _circle2, _circle3, _path144, _path145, _path146, _path147, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _ellipse, _ellipse2, _polygon8, _rect27, _polygon9, _polygon10, _polygon11, _polygon12, _circle4, _ellipse3, _polygon13, _path157, _path158, _path159, _rect28, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _polygon14, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _polygon15, _path185, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _ellipse4, _polygon23, _polygon24, _polygon25, _path186, _path187, _polyline, _line17, _path188, _path189, _line18, _rect29, _polygon26, _path190, _path191, _path192, _path193, _polygon27, _path194, _polygon28, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _path212, _polygon34, _polygon35, _polygon36, _line19, _line20, _path213, _path214, _path215, _path216, _path217, _path218;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIot01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1",
    xmlns: "http://www.w3.org/1000/svg",
    viewBox: "0 0 2007.29 1476.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5f0f8;}.cls-2{fill:#40a87b;}.cls-11,.cls-18,.cls-24,.cls-26,.cls-28,.cls-3,.cls-31,.cls-33,.cls-34,.cls-35,.cls-5{fill:none;}.cls-18,.cls-3{stroke:#6adb6a;}.cls-11,.cls-18,.cls-26,.cls-28,.cls-3,.cls-31,.cls-33,.cls-34,.cls-5{stroke-miterlimit:10;}.cls-3,.cls-5{stroke-width:4.54px;}.cls-4{fill:#6adb6a;}.cls-5{stroke:#40a87b;}.cls-6{fill:#df941e;}.cls-7{fill:#bbdbf3;}.cls-8{fill:#93c3e6;}.cls-9{fill:#fff;}.cls-10{fill:#93acbf;}.cls-11{stroke:#f9ecb8;stroke-width:3.52px;}.cls-12{fill:#088cfc;}.cls-13{fill:#586773;}.cls-14{fill:#f74242;}.cls-15{fill:#f9e181;}.cls-16{fill:#2ec6fc;}.cls-17{fill:#0775ef;}.cls-18{stroke-width:3.89px;}.cls-19{fill:#fdae97;}.cls-20{fill:#322a28;}.cls-21{fill:#b86b76;}.cls-22{fill:#332b27;}.cls-23{fill:#e89780;}.cls-24,.cls-33{stroke:#e89780;}.cls-24,.cls-35{stroke-linecap:round;stroke-linejoin:round;}.cls-24{stroke-width:0.64px;}.cls-25{fill:#2c3447;}.cls-26,.cls-34{stroke:#2c3447;}.cls-26{stroke-width:0.95px;}.cls-27{fill:#e7888b;}.cls-28,.cls-31,.cls-35{stroke:#fff;}.cls-28{stroke-width:0.84px;}.cls-29{fill:#a5bbd6;}.cls-30{fill:#89a5c7;}.cls-31{stroke-width:1.24px;}.cls-32{fill:#403534;}.cls-33{stroke-width:0.66px;}.cls-34{stroke-width:0.82px;}.cls-35{stroke-width:0.44px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1736.66,1444.28S2293.28-99.42,1271.82,5.08C834.32,49.83,916,321.34,722.77,575.39c-125.25,164.67-366.14,30-456.41,173.85s15.82,554.19,53,695Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.41,1448.78S365,1287.62,264.29,1237.88s-208.21,18.35-180.91,90c23.53,61.74,120.31-14.18,195.62,15.68s87.17,105.26,87.17,105.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.84,1284.9s108.1-61.6,188.3-4.65,105.57,168.53,105.57,168.53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.28,
    y1: 1256.09,
    x2: 145.43,
    y2: 1267.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 156.6,
    y1: 1232.6,
    x2: 206.69,
    y2: 1256.09
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 231.86,
    y1: 1232.6,
    x2: 257.92,
    y2: 1263.38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 281.26,
    y1: 1253.23,
    x2: 292.97,
    y2: 1281.58
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 132.85,
    y1: 1324.13,
    x2: 171.46,
    y2: 1260.25
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.06,
    y1: 1314.97,
    x2: 236.47,
    y2: 1258.11
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 261.21,
    y1: 1306.26,
    x2: 314.44,
    y2: 1299.64
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.18,
    y1: 1338.51,
    x2: 353.69,
    y2: 1348.53
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M450.59,1443.71S479.1,903.48,221.07,973.1,422.35,1333.87,422,1443.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.16,1443.71s-9-282.25-192.94-421.81"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 327.89,
    y1: 1103.74,
    x2: 323.3,
    y2: 1006.41
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 183.58,
    y1: 1063.41,
    x2: 307.91,
    y2: 1079.61
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 231.93,
    y1: 1146.47,
    x2: 363.38,
    y2: 1161.79
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 297.66,
    y1: 1228.79,
    x2: 399.18,
    y2: 1243.14
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 408.92,
    y1: 1151.88,
    x2: 385.65,
    y2: 1208.42
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 370.69,
    y1: 1060.12,
    x2: 350.85,
    y2: 1139.72
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 430.65,
    y1: 1246.26,
    x2: 412.11,
    y2: 1283.22
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 350.85,
    y1: 1305.1,
    x2: 423.6,
    y2: 1328.04
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M910.64,451.59a457,457,0,0,0-9.44-81.81c-.31-1.68-.66-3.3-1-4.92C856.79,167.18,685.05,17.61,476.81,8c-7.1-.36-14.26-.51-21.47-.51A454.7,454.7,0,0,0,278,43.34c-11.27,4.77-22.28,10-33,15.58A456.18,456.18,0,0,0,11.62,360.08c-.61,2.69-1.22,5.38-1.77,8.07A459,459,0,0,0,0,462.91,454.3,454.3,0,0,0,34.26,636.53C102.47,801.88,265.33,918.3,455.34,918.3A453.68,453.68,0,0,0,599.58,895Q617,889.17,633.74,882c122.11-52,216.86-155.86,256.6-283.86a456.26,456.26,0,0,0,20.4-135.25C910.74,459.1,910.74,455.35,910.64,451.59Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M910.74,462.91A453.37,453.37,0,0,1,808.93,750l0,0A456.77,456.77,0,0,1,633.74,882Q617,889.18,599.58,895A453.68,453.68,0,0,1,455.34,918.3c-190,0-352.87-116.42-421.08-281.77A454.3,454.3,0,0,1,0,462.91a459,459,0,0,1,9.85-94.76c.55-2.69,1.16-5.38,1.77-8.07A456.18,456.18,0,0,1,244.93,58.92c3.35-1.72,6.75-3.45,10.15-5.07,7.51-3.71,15.12-7.21,22.89-10.51A454.7,454.7,0,0,1,455.34,7.51c7.21,0,14.37.15,21.47.51,208.24,9.59,380,159.16,423.37,356.84.36,1.62.71,3.24,1,4.92a457,457,0,0,1,9.44,81.81C910.74,455.35,910.74,459.1,910.74,462.91Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.74,462.91A453.37,453.37,0,0,1,808.93,750l0,0q-10.82,5.32-21.92,10c-11.17,4.77-22.54,9.08-34.21,12.94a456.1,456.1,0,0,1-402.51-56.94A446.63,446.63,0,0,1,312.58,687a456.24,456.24,0,0,1-125.1-172.41q-5-12.18-9.34-24.66a463.54,463.54,0,0,1-13.86-48.52,461.13,461.13,0,0,1-1.21-195.19c.55-2.69,1.16-5.38,1.72-8.07a455.74,455.74,0,0,1,54.86-134.24c1.88-3,3.81-6.09,5.74-9.14v0a451.3,451.3,0,0,1,29.69-40.85c7.51-3.71,15.12-7.21,22.89-10.51A454.7,454.7,0,0,1,455.34,7.51c7.21,0,14.37.15,21.47.51,208.24,9.59,380,159.16,423.37,356.84.36,1.62.71,3.24,1,4.92a457,457,0,0,1,9.44,81.81C910.74,455.35,910.74,459.1,910.74,462.91Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M910.76,462.9a454.81,454.81,0,0,1-20.44,135.28c-3.91-6-4.24-15.43-4.74-18.87-.7-5-7.8,7.8-8.86,3.78s3.9-23.3-.36-25.07-6.37,2.84-10.27,4.61-3.56,9.93-7.82,10.65-9.57,10.63-12.4,15.6-9.93,7.45-14.19,9.22-7.8,9.23-9.23,13.83-6.39,6.39-11.35,5.32.36-24.11.36-28.72-.7-7.81-4.6-12.06-3.92-19.87-5-22.71-3.19-5.32-5-8.16,3.19-6.73,2.85-11.33.34-8.52,5.31-12.06,2.49-5.69,3.19-9.22,6.4-5,8.16-6.76-.36-4.24,4.61-5.67,11-13.46,10.29-17,2.83-7.8,3.9-7.8,2.85-2.13,2.49-4.26-1.07-4.26,1.77-7.09,6.73-8.87,5.66-12.42.37-7.8,1.43-12.76,1.77-5.33,4.26-4.61,6,6.37,8.83,6.37,3.23-2.11,2.87-7.79-3.2-9.57-2.83-13.37,5.66-5.06,6.73-6.85,1.43-6.74,3.56-6,5,0,9.22.36-2.13,17,0,20.56,15.23,10.65,15.23,10.65,1.07-18.45-.7-25.88-2.83-28.38-1.77-24.48,2.84,12.05,7.1,19.15,3.9,15.25,5.32,23.76c1.27,7.65,5.41,18.45,6.23,20.56C910.72,455.36,910.76,459.12,910.76,462.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M279.69,842.84c-9.44,1.87-36.44-7.11-51.05-18.48s-72.38-55.32-80.9-59.58-16.09-34.06-24.57-48.21-23.19-30.3-30.75-36.9S73,658,69.73,650.33,56,632.82,51.77,631,48,611.1,40.4,609.22c-4.52-1.11-5.79,14.47-6.14,27.31A454.3,454.3,0,0,1,0,462.91a459,459,0,0,1,9.85-94.76c4.41-5,10.25-8.17,24.31-10.5s2.48,8.47,0,14.67-2.24,10.86,0,18,18.06,9.44,26.59,11.83-1.42-9.95,0-18.93,17.51-2.85,21.72-1,15.63,0,20.35-.45,11.37-4.27,20.81-5.69,5.69,5.23,2.84,12.79-3.3,9.9-2.38,18S140.18,436.62,143,439s5.68,5.69,7.56,13.25,3.81,18.47,7.56,18,4.72,7.62,14.21,15.64a37,37,0,0,0,5.79,4.11q4.34,12.48,9.34,24.66a454.8,454.8,0,0,0,49.28,89.33c-1.22,2-2.39,3.75-3.4,5.27-5.69,8.43-6.65,31.27-3.3,36.44s6.6,9.44,12.28,18.43,8.53,5.22,14.16,8.52,12.79,18,18.93,25.58,7.1,16.09-1.42,19.85-8,19.38-9.9,26,10.36,7.11,13.25,13.7,9.44,6.65,10.35,10.46-9,12.28-6.14,16.54,12.28,13.71,9.95,19.85,1.42,16.54,3.3,25.07S289.13,840.91,279.69,842.84Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M266,518c-1.88,11.78-1.42,18.88-1,27.87s-6.6,16.54-10.87,26.95c-3.5,8.57-11.47,22-17.4,31.11a454.8,454.8,0,0,1-49.28-89.33q-5-12.18-9.34-24.66c5.48,3,8.58,1.67,12.18,2,4.72.45,9.9,11.32,14.16,18.42s11.82,9.95,15.17,11.83,7.06-4.22,14.16-8.48a152,152,0,0,1,17.51-9c7.11-3.35,7.56-9.49,13.71-10S267.87,506.15,266,518Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.39,94.75c-1.93,3-3.86,6.09-5.74,9.14a455.74,455.74,0,0,0-54.86,134.24c-.56,2.69-1.17,5.38-1.72,8.07a461.13,461.13,0,0,0,1.21,195.19c-2-2.44-4.06-4.92-6.14-7.61-7.56-9.95-18-21.27-21.87-31.67s1.06-15.18,2.43-26.5-1.37-12.78-2.28-16.08,5.94-29,4.72-29.8c-5.68-3.4-16,5.89-24.51,10.51s-17.71,2.13-20.56-3.55,5.33-9.54,8.88-22.33-5.32-8.12-9.54-7.82S88,311.16,81.2,318.26s1.07,19.14-2.13,26.6-6-4.26-9.95-11.37.36-7.76,1.78-19.49-1.07-19.49-6.39-30.5-8.84,20.91-17.36,23-9.59,12.44-14.57,21-3.85,15.94-6,23c-1.92,6.3-7.56,10.66-15,9.54A452.9,452.9,0,0,1,66.48,225.85c14-1.63,19.8-11,23.6-11.27s7.31-.71,17-3.81,2.58-5.63,3.75-8.73,12.08-4.26,17-6.14,1.88-6.14,3-15.12,4.26-3.81,10.2-7.11,7.31-5.88,6.14-7.56-8.27,2.84-9.95.71,2.59-10.4-.2-9-5.94,7.1-5.94,12.53-5.17,8-9.44,16.09-6.19,5.89-12.28,7.11-8.07-1-11.62-1.22,3.35-7.56,9.24-14.67,9.23-13.19,16.34-18.67,6.34-9.24,12.74-14.87S151,130.64,162.41,125s14.21,1.42,14.21,1.42,5.17,3.81,17-9.44,5.68-5.68,16.54-10.86C219.86,101.45,220.92,99.42,225.39,94.75Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M695.86,390.28c.45,3.3-9.49,5.64-20.35-2.64s-16.55-7.31-24.57-12.48-11.82-8.07-18.93-20.35-5.23-16.55-8.52-25.53-10.87-4.26-14.22,1.42-14.61,3.75-22.22,1.42-7.52-10.4-21.27-17.51-18-1.88-28.83-1-21.31,11.82-29.33,16.08-5.69,7.57-6.14,14.67-12.79,25.53-19.39,31.67-1,7.56,4.72,18,5.23,6.65,3.81,13.7-4.72,12.79-5.23,22.74-4.26,16.09-9.44,16.09-13.25-10.46-18-20.36-13.75-12.79-28.37-20.8-9.94-10.86-17.05-23.65-11.82-17.06-13.7-11.37-9,0-21.77-2.34-13.71-9.49-24.57-16.09-18,3.3-24.61,5.33-16.09,8.38-23.75,11.68-19.29,1-26.8,2.38-19.9.46-29.34,0-12.79-8-22.23-14.06-11.82.82-15.63,4.62,1.88,6.14,9.34,13.25,10.56,5.17,18.12,12.28,14.62,12.28,20.81,5.18,9.89-5.69,18-5.18,18.93-2.84,24.11-2.39,4.72,16.09-.46,25.08,2.34,21.72,0,24.1-10.4,3.35-15.63,7.56-8,9.95-17.51,13.25-7.56,9.49-9.44,16.09-14.21,11.82-25.07,18-13.24,17.5-20.35,18-4.72-11.32-8-22.68-17.51-9.44-24.11-21.47c-4.87-8.78-10.15-15-15.63-21.52a461.13,461.13,0,0,1-1.21-195.19c.55-2.69,1.16-5.38,1.72-8.07a455.74,455.74,0,0,1,54.86-134.24c1.88-3,3.81-6.09,5.74-9.14v0c.56-.61,1.17-1.21,1.83-1.87,6.14-6.15,12.28-5.69,21.72-5.69S263.6,85.26,272.13,81s-1.88-12.79,3.76-21.26,21.77-5.23,26.95-9.5,9-7.56,19.43-10.86S337.85,33.24,344,28c2.38-2,6.14-5.59,9.84-9.14A455.22,455.22,0,0,1,455.34,7.51c7.21,0,14.37.15,21.47.51C482,11,486.66,13.2,489.2,13.35c8,.46,12.28,1.93,25.07,6.19s12.28,7.05,17,11.32,6.6-.46,18.93-3.81,9,7.61,25.07,9.49,29.28,17,39.23,23.2,12.28,6.59,8,14.16-2.79,9,.51,17,10.86,5.17,14.67,6.34,11.31,6.4,17.45,9.7,10.41,12.33,7.11,16.54S648.1,124,647.14,116s-10.41-7.06-18.43-15.53-8.52,2.28-11.82,7-6.14,2.84-12.34-4.21-5.63,1-9.44,7,1.88,10,7.57,14.67,7.1-.91,9.94-2.79,8.48-7.1,7.11,0,1.88,13.25,7,10.35,6.65,3.81,12.79,10.92,12.74,8.47,23.65,12.73,6.6,9.49,10.41,19.9,6.6,20.81,6.14,29.79.91,13.7-6.14,23.14-8.07,10.41-20.35,15.13-4.72.5-9.95,2.84-4.21,7.56-5.63,17.51,3.75,8,11.31,14.21,15.63,4.72,26,8,9.9,6.6,13.7,14.21,4.72,10.86.46,17-1.88,12.79-1.42,22.23-7.11,8-9-4.72-6.59-3.81-13.7-3.81-10.4-5.68-18.93-8-7,1.43-12.28,8.53,4.26,15.58,7.1,23.14,11.83,6.65,24.11,10.41,9.95,2.38,17,10.91S695.35,386.93,695.86,390.28Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M351.56,757.93c-5.43,1.67-16.09-4-25.07-8.73s-2.59-6.85-3.05-16.8-5.94-10.4-11.11-15.12-8.78-10.16-12.08-15.13c-2.79-4.21,3-9.59,12.33-15.17a446.63,446.63,0,0,0,37.66,29.08,33,33,0,0,1,1.32,6.19c1,8.47,6.85,15.38,8.07,24.11S357,756.3,351.56,757.93Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M350.24,716.06A446.63,446.63,0,0,1,312.58,687c1.73-1,3.5-2,5.43-3.05,12.28-6.6-4.31-23.34,5.43-22.68,6.85.45,7.56,4,11.12,9.18s7.3,8.07,10.15,13.76,1.16,8.27,1.42,16C346.33,706,348.66,710.63,350.24,716.06Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M622.42,396.29c-2.78-8,15.61-9.57,22.7-5s11.7,10.28,21.63,12.06,11,1.42,17,0S698,394.87,699,402s-2.48,11.7,3.55,13.83,13.12,2.13,18.08,4.61,3.91,2.13,5.32,7.8,5,15.61-.7,15.61-10.64-3.55-22.35-5-14.19-1.06-22.34-8.86.35-5.68-14.19-10.29-17-9.93-25.18-14.89S624.9,403.39,622.42,396.29Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M734.14,443.82c3.19,6.77,10.29-2.84,16.67-4.61s5-.36,12.41-1.77,9.23-9.94,15.26-9.23-3.91-7.09-10.29-5-7.09,2.13-16,5.32S731.3,437.79,734.14,443.82Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M901.22,369.77c-2.65-1.25-5-2.5-5.35-3.16-.94-1.65-4.26-9.93-7.33-12.28s-1.65,6.37-.23,11.58,1,7.33-1.66,5.91-4-.95-6.86,1.66-5,2.11-3.53-9-3-10.71-10.17-13.73c-4.22-1.74-9.23-1.18-14.19-1.89s-8.77-4.26-11.6-9,3.08-9.47,7.34-9.93,2.37,7.34,10.63,11.82,1.43-5.21,2.13-13.71,7.82-2.13,15.86-1.18,7.55,9.22,10.15,14.65,4.74,8.52,6.39,13.95c.7,2.33,3.94,6,7.37,9.34C900.53,366.49,900.9,368.12,901.22,369.77Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M729.18,374.78c-2.64,7,2.83,12.41,6.14,15.72a54.26,54.26,0,0,1,8.28,11.11c1.65,3.08,4.26,5,8.51,1.66s4.26-7.09,12.06-6.62,12.06,8.27,14.66.23,1.38-9,1.52-15.36,5.1-14.66,2.5-18.92-8.08-5.67-2.5-9.93.61-5.68-3.41-6.62-9.46-1.66-9.93-7.57,1.42-9,3.31-12.77,4.49-9.22-3.78-7.09-15.14,2.13-14.19,9.22.23,11.59-5.2,15.61-.71,13.56-3.55,18.13S730.83,370.42,729.18,374.78Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M646.18,69.64C638,70.9,656.47,75,661.43,82.76s16,7.1,11.35,17-7.09,8.51-5,14.54-4.26,11.35,1.06,11.35,12.06-1.77,17.38,5,5.32.35.71-8.52-5.32-11.7-2.84-16a14.15,14.15,0,0,0-1.77-16.67c-5-5.67-8.33-3.9-14.1-9.93S650.79,68.93,646.18,69.64Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M497,417.93c-4.94,2.23-1.77,8.69.18,12.94s-1.59,6.92,2.48,11,9.58,9.93,12.77,7.09,13.13-6.56,8-12.41-7.45-6-11.35-10.29S502.54,415.45,497,417.93Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M791.36,353.14c.87,10.37,5.68,10.64,4,17.74s-2,12.29,1.15,12.29,4.53-17.73,7.6-11.35,6.38,9.7,7.09,5.91-9.22-11.27-5.43-16.15,11.82-17.42,2.36-11.28-13,13.95-14.42,7.1-3.31-9.93,4.73-12.3,14.89-1.89,15.84-7.33,1.65-16.55-5.68-8.75-7.8,6.62-13.71,10.64-11.59,4.26-9.22,7.57S791,348.4,791.36,353.14Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M726.69,229.6c-6.76.34-6,5-1.77,9.93s5,10.64,10.64,16,12.41,7.45,13.83,12.06,6.92-.36,6.65-5.32,6.83-2.84,10.38.71,7.45,3.3,9.22,6.44,8.51-1.83,1.42-6.44-8.16-6.74-15.61-9.58-6.57-2.48-10.2,0-6.11,3.33-10.72-4-3-14.08-6.81-17.62S733.79,229.24,726.69,229.6Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M751.62,430.53a100,100,0,0,1-100,100h-329a78.78,78.78,0,0,1,0-157.56,77.82,77.82,0,0,1,22.66,3.31A78.52,78.52,0,0,1,426,334.72a123.13,123.13,0,0,1,232.68-4A100,100,0,0,1,751.62,430.53Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "480.62 442.41 426.19 374.4 371.76 442.41 402.1 442.41 402.1 491.24 450.28 491.24 450.28 442.41 480.62 442.41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "514.81 423.23 569.25 491.24 623.68 423.23 593.34 423.23 593.34 374.4 545.15 374.4 545.15 423.23 514.81 423.23"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M259.32,273.15H47.12a7,7,0,0,1-7-7V67.53l64-64H259.32a7,7,0,0,1,7,7V266.19A7,7,0,0,1,259.32,273.15Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "59.03 254.28 59.03 75.34 112 22.37 247.41 22.37 247.41 254.28 59.03 254.28"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "77.89 235.41 228.55 235.41 228.55 41.24 119.81 41.24 77.89 83.16 77.89 235.41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "96.76 216.55 96.76 90.97 127.62 60.1 209.68 60.1 209.68 216.55 96.76 216.55"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "115.62 197.69 115.62 98.78 135.44 78.97 190.82 78.97 190.82 197.69 115.62 197.69"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "134.49 178.82 134.49 106.6 143.25 97.83 171.96 97.83 171.96 178.82 134.49 178.82"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M491.71,253.36,476,207.76l-2.58,17.87C445,187,409.09,149.93,329.77,120.17l-53.48,14.06s93.44,10,191.2,95.25l-17.67,4.35Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.09,557.71h-71a3.11,3.11,0,0,1-3.11-3.11V59.67a3.11,3.11,0,0,1,3.11-3.11h71a3.11,3.11,0,0,1,3.11,3.11V554.6A3.11,3.11,0,0,1,1706.09,557.71Zm-67.91-6.22H1703V62.78h-64.8Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.09,112.28h-71a3,3,0,0,1-1.31-.3L1527.52,62.49a3.09,3.09,0,0,1-1.73-3.49,3.12,3.12,0,0,1,3-2.44h283.5a3.11,3.11,0,0,1,1.32,5.93L1707.4,112A3,3,0,0,1,1706.09,112.28Zm-70.33-6.22h69.64l92.89-43.28H1542.87Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1855.37,161.77H1485.79a3.11,3.11,0,0,1-1-6.06l149.29-49.5a3.17,3.17,0,0,1,1-.15h71a3.28,3.28,0,0,1,1,.15l149.28,49.5a3.11,3.11,0,0,1-1,6.06Zm-350.32-6.22h331.06l-130.52-43.27h-70Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1485.79,212.67a3.16,3.16,0,0,1-1.24-.25,3.11,3.11,0,0,1-1.87-2.86V169.22a3.11,3.11,0,0,1,3.11-3.11h43a3.11,3.11,0,0,1,2.12,5.38l-43,40.34A3.09,3.09,0,0,1,1485.79,212.67Zm3.11-40.34v30.06L1521,172.33Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1485.79,284.09a3.11,3.11,0,0,1-3.11-3.11V209.56a3.11,3.11,0,0,1,6.22,0V281A3.11,3.11,0,0,1,1485.79,284.09Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,283H1481a1.53,1.53,0,0,1-1.52-1.52h0A1.52,1.52,0,0,1,1481,280h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,283Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,274.63H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,274.63Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,266.28H1481a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,266.28Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,257.92H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,257.92Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,249.57H1481a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,249.57Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,241.21H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,241.21Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,232.86H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.53,1.53,0,0,1,1.52-1.52h9.68a1.52,1.52,0,0,1,1.51,1.52h0A1.52,1.52,0,0,1,1490.63,232.86Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,224.5H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,224.5Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,216.15H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.53,1.53,0,0,1,1.52-1.52h9.68a1.52,1.52,0,0,1,1.51,1.52h0A1.52,1.52,0,0,1,1490.63,216.15Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1855.37,212.67a3.09,3.09,0,0,1-2.12-.84l-43-40.34a3.11,3.11,0,0,1,2.12-5.38h43a3.11,3.11,0,0,1,3.11,3.11v40.34a3.11,3.11,0,0,1-1.87,2.86A3.16,3.16,0,0,1,1855.37,212.67Zm-35.17-40.34,32.06,30.06V172.33Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1855.37,284.09a3.11,3.11,0,0,1-3.11-3.11V209.56a3.11,3.11,0,0,1,6.22,0V281A3.11,3.11,0,0,1,1855.37,284.09Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,283h9.68a1.52,1.52,0,0,0,1.52-1.52h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,283Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,274.63h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,274.63Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,266.28h9.68a1.52,1.52,0,0,0,1.52-1.52h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,266.28Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,257.92h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,257.92Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,249.57h9.68a1.52,1.52,0,0,0,1.52-1.52h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,249.57Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,241.21h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,241.21Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,232.86h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.52h-9.68a1.52,1.52,0,0,0-1.51,1.52h0A1.52,1.52,0,0,0,1850.53,232.86Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,224.5h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68A1.52,1.52,0,0,0,1849,223h0A1.52,1.52,0,0,0,1850.53,224.5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,216.15h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.52h-9.68a1.52,1.52,0,0,0-1.51,1.52h0A1.52,1.52,0,0,0,1850.53,216.15Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1855.37,557.72H1485.79a3.11,3.11,0,0,1-1-6.06l149.29-49.5a2.9,2.9,0,0,1,1-.16h71a3,3,0,0,1,1,.16l149.28,49.5a3.11,3.11,0,0,1-1,6.06Zm-350.32-6.22h331.06l-130.52-43.28h-70Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1485.79,607.28a3,3,0,0,1-1.24-.26,3.09,3.09,0,0,1-1.87-2.85V563.82a3.11,3.11,0,0,1,3.11-3.11h43a3.11,3.11,0,0,1,2.12,5.38l-43,40.35A3.09,3.09,0,0,1,1485.79,607.28Zm3.11-40.35V597L1521,566.93Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1485.79,678.69a3.11,3.11,0,0,1-3.11-3.11V604.17a3.11,3.11,0,0,1,6.22,0v71.41A3.11,3.11,0,0,1,1485.79,678.69Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,669.24H1481a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,669.24Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,660.88H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,660.88Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,652.53H1481a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,652.53Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,644.17H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,644.17Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,635.82H1481a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,635.82Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,627.46H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,627.46Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,619.11H1481a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,619.11Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1490.63,610.75H1481a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51h9.68a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1490.63,610.75Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1855.37,607.28a3.09,3.09,0,0,1-2.12-.84l-43-40.35a3.11,3.11,0,0,1,2.12-5.38h43a3.11,3.11,0,0,1,3.11,3.11v40.35a3.09,3.09,0,0,1-1.87,2.85A3,3,0,0,1,1855.37,607.28Zm-35.17-40.35L1852.26,597V566.93Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1855.37,678.69a3.11,3.11,0,0,1-3.11-3.11V604.17a3.11,3.11,0,0,1,6.22,0v71.41A3.11,3.11,0,0,1,1855.37,678.69Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,669.24h9.68a1.53,1.53,0,0,0,1.52-1.52h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,669.24Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,660.88h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,660.88Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,652.53h9.68a1.52,1.52,0,0,0,1.52-1.52h0a1.52,1.52,0,0,0-1.52-1.51h-9.68A1.52,1.52,0,0,0,1849,651h0A1.52,1.52,0,0,0,1850.53,652.53Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,644.17h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,644.17Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,635.82h9.68a1.52,1.52,0,0,0,1.52-1.52h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,635.82Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,627.46h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68A1.52,1.52,0,0,0,1849,626h0A1.52,1.52,0,0,0,1850.53,627.46Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,619.11h9.68a1.52,1.52,0,0,0,1.52-1.52h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,619.11Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1850.53,610.75h9.68a1.52,1.52,0,0,0,1.52-1.51h0a1.52,1.52,0,0,0-1.52-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1850.53,610.75Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1903.94,456.77a3.13,3.13,0,0,1-2.13-.84l-43-40.35a3.11,3.11,0,0,1,2.13-5.38h43a3.11,3.11,0,0,1,3.11,3.11v40.35a3.09,3.09,0,0,1-1.87,2.85A3,3,0,0,1,1903.94,456.77Zm-35.17-40.35,32.06,30.06V416.42Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1903.94,528.19a3.12,3.12,0,0,1-3.11-3.12V453.66a3.11,3.11,0,1,1,6.22,0v71.41A3.12,3.12,0,0,1,1903.94,528.19Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1897.59,
    y: 524.05,
    width: 12.71,
    height: 3.03,
    rx: 1.51,
    transform: "translate(3807.88 1051.14) rotate(180)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,518.73h9.68a1.52,1.52,0,0,0,1.51-1.52h0a1.52,1.52,0,0,0-1.51-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1899.1,518.73Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,510.37h9.68a1.52,1.52,0,0,0,1.51-1.51h0a1.52,1.52,0,0,0-1.51-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1899.1,510.37Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,502h9.68a1.52,1.52,0,0,0,1.51-1.52h0a1.52,1.52,0,0,0-1.51-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1899.1,502Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,493.66h9.68a1.52,1.52,0,0,0,1.51-1.51h0a1.52,1.52,0,0,0-1.51-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1899.1,493.66Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,485.31h9.68a1.52,1.52,0,0,0,1.51-1.52h0a1.52,1.52,0,0,0-1.51-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1899.1,485.31Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,477h9.68a1.52,1.52,0,0,0,1.51-1.51h0a1.52,1.52,0,0,0-1.51-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1899.1,477Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,468.6h9.68a1.52,1.52,0,0,0,1.51-1.51h0a1.52,1.52,0,0,0-1.51-1.52h-9.68a1.52,1.52,0,0,0-1.51,1.52h0A1.52,1.52,0,0,0,1899.1,468.6Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1899.1,460.24h9.68a1.52,1.52,0,0,0,1.51-1.51h0a1.52,1.52,0,0,0-1.51-1.51h-9.68a1.52,1.52,0,0,0-1.51,1.51h0A1.52,1.52,0,0,0,1899.1,460.24Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1443.19,456.77a3,3,0,0,1-1.24-.26,3.09,3.09,0,0,1-1.87-2.85V413.31a3.11,3.11,0,0,1,3.11-3.11h43a3.11,3.11,0,0,1,2.12,5.38l-43,40.35A3.13,3.13,0,0,1,1443.19,456.77Zm3.11-40.35v30.06l32.06-30.06Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1443.19,528.19a3.12,3.12,0,0,1-3.11-3.12V453.66a3.11,3.11,0,1,1,6.22,0v71.41A3.12,3.12,0,0,1,1443.19,528.19Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1436.83,
    y: 524.05,
    width: 12.71,
    height: 3.03,
    rx: 1.51
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,518.73h-9.68a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51H1448a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1448,518.73Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,510.37h-9.68a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51H1448a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1448,510.37Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,502h-9.68a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51H1448a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1448,502Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,493.66h-9.68a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51H1448a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1448,493.66Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,485.31h-9.68a1.53,1.53,0,0,1-1.52-1.52h0a1.52,1.52,0,0,1,1.52-1.51H1448a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1448,485.31Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,477h-9.68a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51H1448a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1448,477Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,468.6h-9.68a1.52,1.52,0,0,1-1.52-1.51h0a1.53,1.53,0,0,1,1.52-1.52H1448a1.52,1.52,0,0,1,1.51,1.52h0A1.52,1.52,0,0,1,1448,468.6Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1448,460.24h-9.68a1.52,1.52,0,0,1-1.52-1.51h0a1.52,1.52,0,0,1,1.52-1.51H1448a1.52,1.52,0,0,1,1.51,1.51h0A1.52,1.52,0,0,1,1448,460.24Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1528.83,76.91a3.11,3.11,0,0,1-3.11-3.11V59.67a3.11,3.11,0,0,1,6.22,0V73.8A3.11,3.11,0,0,1,1528.83,76.91Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1812.33,76.91a3.11,3.11,0,0,1-3.11-3.11V59.67a3.11,3.11,0,0,1,6.22,0V73.8A3.11,3.11,0,0,1,1812.33,76.91Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1904.33,409.1H1436.84a3.11,3.11,0,0,1-.92-6.08l198.23-61.33a3.21,3.21,0,0,1,.92-.14h71a3.21,3.21,0,0,1,.92.14L1905.25,403a3.11,3.11,0,0,1-.92,6.08Zm-446.92-6.22h426.34l-178.13-55.11h-70.08Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1865.68,1444.28h-40.45a3.12,3.12,0,0,1-2.73-1.61l-151.92-276.92-151.92,276.92a3.13,3.13,0,0,1-2.73,1.61h-40.46a3.13,3.13,0,0,1-2.39-1.12,3.07,3.07,0,0,1-.67-2.54L1632,554.06a3.1,3.1,0,0,1,3.06-2.56h71a3.12,3.12,0,0,1,3.06,2.56l159.6,886.56a3.12,3.12,0,0,1-3.07,3.66Zm-38.61-6.22H1862L1703.49,557.72h-65.82l-158.48,880.34h34.9l153.76-280.28a3.25,3.25,0,0,1,5.46,0Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,112.28a3.11,3.11,0,0,1-1.78-5.67l71-49.49a3.11,3.11,0,0,1,3.55,5.11l-71,49.49A3.07,3.07,0,0,1,1635.08,112.28Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,112.28a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,0,1,3.55-5.11l71,49.49a3.11,3.11,0,0,1-1.78,5.67Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,161.77a3.11,3.11,0,0,1-1.79-5.66l71-49.5a3.11,3.11,0,0,1,3.56,5.11l-71,49.49A3.07,3.07,0,0,1,1635.08,161.77Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,161.77a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,0,1,3.56-5.11l71,49.5a3.11,3.11,0,0,1-1.79,5.66Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,211.26a3.11,3.11,0,0,1-1.78-5.66l71-49.49a3.11,3.11,0,1,1,3.55,5.1l-71,49.49A3.07,3.07,0,0,1,1635.08,211.26Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,211.26a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,1,1,3.55-5.1l71,49.49a3.11,3.11,0,0,1-1.78,5.66Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,260.76a3.12,3.12,0,0,1-1.79-5.67l71-49.49a3.11,3.11,0,1,1,3.56,5.1l-71,49.5A3.14,3.14,0,0,1,1635.08,260.76Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,260.76a3.14,3.14,0,0,1-1.77-.56l-71-49.5a3.11,3.11,0,0,1,3.56-5.1l71,49.49a3.12,3.12,0,0,1-1.79,5.67Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,310.25a3.11,3.11,0,0,1-1.78-5.66l71-49.5a3.11,3.11,0,0,1,3.55,5.11l-71,49.49A3.07,3.07,0,0,1,1635.08,310.25Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,310.25a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,0,1,3.55-5.11l71,49.5a3.11,3.11,0,0,1-1.78,5.66Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,359.74a3.11,3.11,0,0,1-1.79-5.66l71-49.49a3.11,3.11,0,1,1,3.56,5.1l-71,49.49A3.07,3.07,0,0,1,1635.08,359.74Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,359.74a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,0,1,3.56-5.1l71,49.49a3.11,3.11,0,0,1-1.79,5.66Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,409.23a3.11,3.11,0,0,1-1.78-5.66l71-49.49a3.11,3.11,0,1,1,3.55,5.1l-71,49.49A3.07,3.07,0,0,1,1635.08,409.23Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,409.23a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,1,1,3.55-5.1l71,49.49a3.11,3.11,0,0,1-1.78,5.66Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,458.73a3.11,3.11,0,0,1-1.79-5.66l71-49.5a3.11,3.11,0,1,1,3.56,5.1l-71,49.5A3.07,3.07,0,0,1,1635.08,458.73Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,458.73a3.07,3.07,0,0,1-1.77-.56l-71-49.5a3.11,3.11,0,0,1,3.56-5.1l71,49.5a3.11,3.11,0,0,1-1.79,5.66Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,508.22a3.11,3.11,0,0,1-1.78-5.66l71-49.49a3.11,3.11,0,1,1,3.55,5.1l-71,49.49A3.07,3.07,0,0,1,1635.08,508.22Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,508.22a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,1,1,3.55-5.1l71,49.49a3.11,3.11,0,0,1-1.78,5.66Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.08,557.71a3.11,3.11,0,0,1-1.79-5.66l71-49.49a3.11,3.11,0,1,1,3.56,5.1l-71,49.49A3.07,3.07,0,0,1,1635.08,557.71Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.08,557.71a3.07,3.07,0,0,1-1.77-.56l-71-49.49a3.11,3.11,0,0,1,3.56-5.1l71,49.49a3.11,3.11,0,0,1-1.79,5.66Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1618,652.61a3,3,0,0,1-2.11-.83,3.11,3.11,0,0,1-.17-4.4l88.1-94.89a3.11,3.11,0,0,1,4.56,4.23l-88.1,94.9A3.08,3.08,0,0,1,1618,652.61Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1722.64,652.61a3.13,3.13,0,0,1-2.29-1l-87.56-94.89a3.11,3.11,0,1,1,4.57-4.22l87.57,94.89a3.11,3.11,0,0,1-2.29,5.22Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1596.83,770.15a3.11,3.11,0,0,1-2.12-5.38l125.81-117.54a3.11,3.11,0,1,1,4.24,4.54L1599,769.31A3.08,3.08,0,0,1,1596.83,770.15Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1744.33,770.15a3.13,3.13,0,0,1-2.12-.83L1615.87,651.78a3.11,3.11,0,1,1,4.24-4.56l126.34,117.54a3.11,3.11,0,0,1-2.12,5.39Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1767.77,900.38H1573.39a3.12,3.12,0,0,1-1.89-5.59l94-71.56-70.51-53.71a3.11,3.11,0,0,1,3.78-4.95l71.86,54.75,71.86-54.75a3.11,3.11,0,1,1,3.77,4.95l-70.5,53.71,94,71.56a3.12,3.12,0,0,1-1.89,5.59Zm-185.17-6.22h176l-88-67Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1621,1252.85a3.1,3.1,0,0,1-2.14-.86l-94.73-90.46a3.12,3.12,0,0,1,2.14-5.37h288.72a3.11,3.11,0,0,1,2.14,5.37L1722.35,1252a3.11,3.11,0,0,1-4.3-4.5l89.13-85.1H1534l89.11,85.1a3.11,3.11,0,0,1-2.15,5.36Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1789.25,1019.67H1551.91a3.11,3.11,0,1,1,0-6.22h237.34a3.11,3.11,0,0,1,0,6.22Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1574.55,1337.43a3.1,3.1,0,0,1-2.25-1l-67.17-70.39a3.11,3.11,0,0,1,4.5-4.29l67.17,70.39a3.1,3.1,0,0,1-.11,4.39A3.06,3.06,0,0,1,1574.55,1337.43Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1766.61,1337.43a3.11,3.11,0,0,1-2.25-5.25l67.17-70.39a3.11,3.11,0,0,1,4.5,4.29l-67.17,70.39A3.1,3.1,0,0,1,1766.61,1337.43Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1581.79,557.72a2.89,2.89,0,0,1-.92-.14l-45.63-14.12V554.6a3.11,3.11,0,1,1-6.22,0V539.24a3.12,3.12,0,0,1,4-3l45.63,14.12V522.78a3.1,3.1,0,0,1,4.7-2.67l53.29,31.82a3.11,3.11,0,0,1-3.19,5.34l-48.58-29v26.35a3.12,3.12,0,0,1-3.11,3.11Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1759.37,557.72a3.15,3.15,0,0,1-1.85-.61,3.1,3.1,0,0,1-1.26-2.5V528.26l-48.58,29a3.11,3.11,0,0,1-3.19-5.34l53.29-31.82a3.1,3.1,0,0,1,4.7,2.67v27.61l45.63-14.12a3.11,3.11,0,0,1,4,3V554.6a3.11,3.11,0,0,1-6.22,0V543.46l-45.63,14.12A2.89,2.89,0,0,1,1759.37,557.72Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1759.37,161.77a3.15,3.15,0,0,1-1.85-.61,3.1,3.1,0,0,1-1.26-2.5V132.31l-48.58,29a3.11,3.11,0,0,1-3.19-5.34l53.29-31.82a3.1,3.1,0,0,1,4.7,2.67v27.61l45.63-14.12a3.11,3.11,0,0,1,4,3v15.36a3.11,3.11,0,0,1-6.22,0V147.51l-45.63,14.12A3.21,3.21,0,0,1,1759.37,161.77Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1581.79,161.77a3.21,3.21,0,0,1-.92-.14l-45.63-14.12v11.14a3.11,3.11,0,1,1-6.22,0V143.29a3.12,3.12,0,0,1,4-3l45.63,14.12V126.83a3.1,3.1,0,0,1,4.7-2.67L1636.67,156a3.11,3.11,0,0,1-3.19,5.34l-48.58-29v26.35a3.12,3.12,0,0,1-3.11,3.11Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1761.16,86.62a3.16,3.16,0,0,1-1.24-.25l-55.07-23.84a3.11,3.11,0,1,1,2.47-5.71l50.73,22V59.67a3.11,3.11,0,1,1,6.22,0V83.51a3.11,3.11,0,0,1-3.11,3.11Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1580,86.62a3.11,3.11,0,0,1-3.11-3.11V59.67a3.11,3.11,0,1,1,6.22,0V78.78l50.73-22a3.11,3.11,0,0,1,2.47,5.71l-55.07,23.84A3.16,3.16,0,0,1,1580,86.62Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1635.07,409.23a3.09,3.09,0,0,1-1.8-.58l-55.11-39.37V406a3.09,3.09,0,0,1-4,3l-65.66-20v17a3.11,3.11,0,1,1-6.22,0V384.78a3.1,3.1,0,0,1,4-3l65.66,20V363.23a3.11,3.11,0,0,1,4.92-2.53l60,42.89a3.11,3.11,0,0,1-1.81,5.64Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1706.09,409.23a3.11,3.11,0,0,1-1.81-5.64l60-42.89a3.11,3.11,0,0,1,4.92,2.53v38.56l65.66-20a3.09,3.09,0,0,1,4,3V406a3.11,3.11,0,0,1-6.22,0V389L1767,409a3.07,3.07,0,0,1-2.75-.47A3.12,3.12,0,0,1,1763,406V369.28l-55.11,39.37A3.06,3.06,0,0,1,1706.09,409.23Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1898.37,203.29a52.53,52.53,0,0,0,0-74.36l5.34-5.34a60.09,60.09,0,0,1,0,85Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1929.42,234.18a96.38,96.38,0,0,0,0-136.14l5.34-5.34a104,104,0,0,1,0,146.82Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1959.16,264c54-54,54-141.79,0-195.76l5.34-5.34a145.89,145.89,0,0,1,0,206.44Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1438.77,203.29a52.53,52.53,0,0,1,0-74.36l-5.34-5.34a60.09,60.09,0,0,0,0,85Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1407.72,234.18a96.38,96.38,0,0,1,0-136.14l-5.34-5.34a104,104,0,0,0,0,146.82Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1378,264c-54-54-54-141.79,0-195.76l-5.34-5.34a145.92,145.92,0,0,0,0,206.44Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1436.88.3H941C862.41.3,798.09,64.62,798.09,143.16V1295.05c0,78.61,64.32,142.93,142.93,142.93h495.86c78.61,0,142.93-64.32,142.93-142.93V143.16C1579.81,64.62,1515.49.3,1436.88.3Zm40.78,168.09H900.24V142.18A40.82,40.82,0,0,1,941,101.4h495.86a40.82,40.82,0,0,1,40.78,40.78Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1436.88,50.33H941a91.94,91.94,0,0,0-91.86,91.85V1294A92,92,0,0,0,941,1385.92h495.86A92.06,92.06,0,0,0,1528.8,1294V142.18A92,92,0,0,0,1436.88,50.33Zm40.78,118.06H900.24V142.18A40.82,40.82,0,0,1,941,101.4h495.86a40.82,40.82,0,0,1,40.78,40.78Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1477.66,142.18v26.21H900.24V142.18A40.82,40.82,0,0,1,941,101.4h495.86A40.82,40.82,0,0,1,1477.66,142.18Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1477.66,168.39V1294a40.81,40.81,0,0,1-40.78,40.78H941A40.81,40.81,0,0,1,900.24,1294V168.39Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 956.32,
    cy: 134.9,
    r: 16.64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1003.17,
    cy: 134.9,
    r: 16.64
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1050.01,
    cy: 134.9,
    r: 16.64
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1110.54,211h13.62V311.37h-13.62Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1076.74,211h13.62V311.37h-13.62Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1143.45,277.75a34.09,34.09,0,0,1,2.77-13.75,36,36,0,0,1,58.35-11.21,35.89,35.89,0,0,1,7.59,11.21,34.26,34.26,0,0,1,2.77,13.75,35,35,0,0,1-10.36,25,36.1,36.1,0,0,1-11.34,7.52,36.34,36.34,0,0,1-39.43-7.52,35,35,0,0,1-10.35-25Zm13.62,0a27.9,27.9,0,0,0,1.55,9.44,21.28,21.28,0,0,0,4.4,7.37,19.91,19.91,0,0,0,7,4.82,24.74,24.74,0,0,0,18.43,0,20,20,0,0,0,6.95-4.82,21.28,21.28,0,0,0,4.4-7.37,29.31,29.31,0,0,0,0-18.87,21.28,21.28,0,0,0-4.4-7.37,20.28,20.28,0,0,0-6.95-4.82,24.74,24.74,0,0,0-18.43,0,20.18,20.18,0,0,0-7,4.82,21.28,21.28,0,0,0-4.4,7.37A27.89,27.89,0,0,0,1157.07,277.75Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1255.21,223.72h-32.34V211h78.29v12.77h-32.34v87.65h-13.61Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 933.48,
    y: 389.84,
    width: 37.39,
    height: 338.02
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1012.41,
    y: 389.84,
    width: 37.39,
    height: 338.02
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1012.41,
    y: 540.94,
    width: 37.39,
    height: 186.93
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1091.33,
    y: 389.84,
    width: 37.39,
    height: 338.02
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1091.33,
    y: 475.51,
    width: 37.39,
    height: 252.35
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1170.26,
    y: 389.84,
    width: 37.39,
    height: 338.02
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1170.26,
    y: 590.01,
    width: 37.39,
    height: 137.86
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1249.18,
    y: 389.84,
    width: 37.39,
    height: 338.02
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1249.18,
    y: 442.8,
    width: 37.39,
    height: 285.06
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1328.11,
    y: 389.84,
    width: 37.39,
    height: 338.02
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1328.11,
    y: 584.12,
    width: 37.39,
    height: 143.74
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1407.03,
    y: 389.84,
    width: 37.39,
    height: 338.02
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1407.03,
    y: 633.62,
    width: 37.39,
    height: 94.24
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 933.48,
    y: 628.28,
    width: 37.39,
    height: 99.58
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1132.31,784.61C1030.14,810,954.39,902.24,954.39,1012.25a233.56,233.56,0,0,0,51.71,146.85L1189,1012.25Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1329.39,824.36a234.81,234.81,0,0,0-197.08-39.75L1189,1012.25Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1423.33,1005.18a234.16,234.16,0,0,0-93.94-180.82L1189,1012.25Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1423.33,1005.18,1189,1012.25l166.45,165.24a233.82,233.82,0,0,0,68.11-165.24C1423.51,1009.88,1423.4,1007.53,1423.33,1005.18Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1261.26,1235.4a234.57,234.57,0,0,0,94.14-57.91L1189,1012.25Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1006.1,1159.1a234.54,234.54,0,0,0,255.16,76.3L1189,1012.25Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.51,288.5l-1.93,52.39,9.61-17.11c13.66,50.32,35.61,102,104.4,163.21l59.75,6.68S153.47,447,87.73,322.2l19.61,2.51Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M599.58,1035.39c0,222.36-47,402.59-105,402.59s-105-180.23-105-402.59,47-402.6,105.05-402.6S599.58,813.06,599.58,1035.39Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M858.62,1035.39c0,222.36-47,402.59-105,402.59h-259c58,0,105-180.23,105-402.59s-47-402.6-105-402.6h259C811.59,632.79,858.62,813.06,858.62,1035.39Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 861.37,
    y: 1074.67,
    width: 20.74,
    height: 15.36
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 878.16,
    y: 1070.07,
    width: 10.63,
    height: 24.54,
    rx: 1.38
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 861.37,
    y: 948.54,
    width: 20.74,
    height: 15.36
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 522.95,
    y: 833.8,
    width: 318.13,
    height: 403.18,
    rx: 31.48
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 554.76,
    y: 833.8,
    width: 318.13,
    height: 403.18,
    rx: 31.48
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 523.27,
    y: 887.36,
    width: 381.1,
    height: 296.06,
    rx: 20.44,
    transform: "translate(1749.21 321.56) rotate(90)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 583.35,
    y: 886.54,
    width: 119.11,
    height: 119.11
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 725.18,
    y: 886.54,
    width: 119.11,
    height: 119.11
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 583.35,
    y: 1060.65,
    width: 119.11,
    height: 119.11
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 725.18,
    y: 1060.65,
    width: 119.11,
    height: 119.11
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 806.45,
    cy: 982.35,
    rx: 15.06,
    ry: 9.66
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 760,
    cy: 974.63,
    rx: 12.04,
    ry: 7.72
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "821.19 982.35 814.59 982.35 814.59 927.26 771.68 909.96 771.68 974.63 765.08 974.63 765.08 900.18 821.19 922.81 821.19 982.35"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 789.83,
    y: 906.65,
    width: 6.6,
    height: 53.6,
    transform: "translate(-372.87 1308.69) rotate(-67.49)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "680.31 946.1 613.3 907.41 613.3 984.78 680.31 946.1"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "685.45 1092.81 640.27 1122.84 595.1 1092.81 685.45 1092.81"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "685.45 1092.81 685.45 1152.88 595.1 1152.88 595.1 1092.81 640.27 1122.84 685.45 1092.81"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "595.1 1152.88 640.27 1122.84 685.45 1152.88 595.1 1152.88"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 685.45,
    cy: 1092.81,
    r: 5.27
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 783.2,
    cy: 1118.37,
    rx: 36.88,
    ry: 23.76
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "816.94 1127.98 823.16 1145.8 783.2 1142.13 798.75 1123.16 816.94 1127.98"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M772.7,1118.37a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,772.7,1118.37Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M787.07,1118.37a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,787.07,1118.37Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M801.44,1118.37a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,801.44,1118.37Z"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 878.16,
    y: 943.94,
    width: 10.63,
    height: 24.54,
    rx: 1.38
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1484.94,815.35c-1.2,2.13,8.5,13.4,17.79,19,7.88,4.76,27.2,13.77,32.92,16.38l15.78-24.64a75.43,75.43,0,0,1-8.18-7.74c-5.74-6.48-23.36-22.34-25.64-19.76s7.63,15.85,5.79,16.14S1512,807,1508.26,803.19s-10.63-13.12-13.7-12.64-3.58,5.05-3.58,5.05-2.19-3.88-4.37-2.07-.27,8.71-.27,8.71-1-2.28-2.85.31,4.45,11.9,4.45,11.9A2,2,0,0,0,1484.94,815.35Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1732.68,669.21c20.47,1.78,38.25,19.18,38.51,44s4.75,37.64,19.78,34.75c0,0-42.09,24.41-97.55,2.88,0,0,6.95-8.25,7.93-26.91S1732.68,669.21,1732.68,669.21Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1625,923.15h0a27,27,0,0,0,36.5-10.95l52.78-98.08a27,27,0,0,0-11-36.49h0a27,27,0,0,0-36.49,11L1614,886.66A27,27,0,0,0,1625,923.15Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1745,955.79c17.64,23.09,24.28,71,13,122.55s-15,85.48-15,85.48a43.55,43.55,0,0,1-86.46-10.61l17.93-197.42Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1748.84,766.46,1796,787.81s-10.49,121.37-11.57,134.65,3,33.33,3,33.33h-113s1.36-65-6.23-83.19c-5.14-12.29-8.67-19.78-5.69-33.86s24.79-39,21.27-63.39l24.59-7.87Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1833.81,942.73h0a27,27,0,0,0,16-34.56l-38.3-104.58a27,27,0,0,0-34.56-16h0a27,27,0,0,0-16,34.56l38.29,104.59A27,27,0,0,0,1833.81,942.73Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1702.67,696.12s-6.42-15.78,9-20.56Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1708.36,712.62v54.84s1.11,12,15.39,13.1c12.33.93,20.2-7.19,23.51-11.52l1.75-2.55,0,0-5.83-53.82Z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "1708.37 761.22 1732.68 734.79 1708.35 743.92 1708.37 761.22"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1732.48,740.64c-11.36,6.7-24.77,6.69-32.86,1.25s-6.76-17.87-4.35-25.78v-.06c.51-1.64,1.22-3.94,2-6.55,3.09-10.22,7.66-25.36,7.66-25.36,2-8,24.91-26,46.61-2.52S1743.84,733.94,1732.48,740.64Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1705.68,680.91s.3,9.59,13.73,16,26.18,16.2,24.57,30.36,3.25,22.14,3.25,22.14,2-17.64,10.89-32.58c3.46-5.8,6.48-18,.75-28.56C1749.82,671.62,1726.47,659,1705.68,680.91Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1741.68,724.22c-2.89,4.26-3.71,7.3-.36,9.57a8.84,8.84,0,0,0,11.93-2.54c2.89-4.27,2.51-9.56-.84-11.83S1744.57,720,1741.68,724.22Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1749.24,727.4a6.29,6.29,0,0,0-5.26-.14c1.94-4.87,7.79-2.9,7.79-2.9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1720.58,711.58c-.53,1.92-2,3.19-3.21,2.85s-1.81-2.18-1.28-4.1,2-3.2,3.21-2.85S1721.12,709.66,1720.58,711.58Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1705,705.59c-.49,1.77-1.82,2.95-3,2.63s-1.68-2-1.19-3.78,1.82-3,3-2.64S1705.48,703.82,1705,705.59Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1640.85,1388.46h76.53l26.27-225,.34-5.15a43.42,43.42,0,0,0-44.78-43.42,43.89,43.89,0,0,0-42.11,40.9Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1727.15,708.54s-2.52-5.85-7.49-5.37"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1707.14,698.77s-2.65-1.3-6.47.9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1780.6,1388.46h73l-23.17-232.35-.07-.81a43.46,43.46,0,0,0-86.82,3.06,36.21,36.21,0,0,0,.2,3.94Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1528.25,862.32l89.37,56.55,5.29,4.39c10.77,7.47,26.57,3.58,35-8.66s6.57-28.36-4.21-35.83l-100.1-56.11-2.22,3.43-15.78,24.64Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1711.45,707s-2.86,9.45-8.76,9.06a12.28,12.28,0,0,0,3.36,3.39"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1709.85,955.81l1,6.33,32.78,200.29a43.56,43.56,0,1,0,86.64-9.1s-4-33.88-4.59-86.69c-.51-40.9-9.78-73.89-24.36-95.23a75.75,75.75,0,0,0-13.94-15.6Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1702.91,727.13s5.47,4.33,11.83-1.26"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1729.86,720c.06,2.07-3.19,3.84-7.26,4s-7.41-1.48-7.47-3.55,3.19-3.85,7.26-4S1729.8,717.88,1729.86,720Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1699.58,715.07c-.66,1.1-2.31,1.41-4.3,1,.51-1.64,1.22-3.94,2-6.55C1699.43,711.45,1700.44,713.69,1699.58,715.07Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1739.75,733.78a3.31,3.31,0,1,0,4.06-2.34A3.32,3.32,0,0,0,1739.75,733.78Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "1868.33 1437.8 1811.96 1437.8 1804.65 1426.66 1804.81 1437.8 1792.4 1437.8 1793.51 1405.62 1790.79 1388.44 1836.7 1388.44 1836.87 1405.62 1868.33 1437.8"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1706.62,767.24l2.85,57.66L1747.26,769c-3.31,4.33-11.18,12.45-23.51,11.52C1709.47,779.5,1706.62,767.24,1706.62,767.24Z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1748.7 763.33 1720.52 780.1 1726.47 790.53 1752.67 768.2 1748.7 763.33"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1708.37 765.74 1720.52 780.1 1713.18 788.95 1705.53 768.38 1708.37 765.74"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1556.86 943.52 1708.64 949.89 1673.79 834.58 1522.02 828.21 1556.86 943.52"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1707.21 944.3 1758.68 902.49 1611.88 896.33 1555.44 937.94 1707.21 944.3"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1559.84 941.13 1711.61 947.5 1676.77 832.18 1524.99 825.82 1559.84 941.13"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1524.99 825.82 1522.02 828.21 1673.79 834.58 1708.64 949.89 1711.61 947.5 1676.77 832.18 1524.99 825.82"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1758.68 902.49 1760.11 908.07 1708.64 949.89 1706.94 944.29 1758.68 902.49"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 1608.87,
    cy: 890.08,
    rx: 7.45,
    ry: 16.84,
    transform: "translate(652.17 2460.24) rotate(-87.6)"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "1665.55 1437.8 1679.03 1427.77 1677.88 1437.8 1690.42 1437.8 1696.58 1405.62 1699.9 1388.44 1651.26 1388.44 1649.39 1405.62 1610.36 1437.8 1665.55 1437.8"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1836.87 1405.62 1868.33 1437.8 1811.96 1437.8 1804.65 1426.66 1804.81 1437.8 1792.4 1437.8 1793.51 1405.62 1836.87 1405.62"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1665.55 1437.8 1679.03 1427.77 1677.88 1437.8 1690.42 1437.8 1696.58 1405.62 1649.39 1405.62 1610.36 1437.8 1665.55 1437.8"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1646,916.08c-2.2,2.25.17,6.19.17,6.19s-4.1-1.8-4.72.94c-.6,2.55,4.24,6.58,4.87,7.1-.46-.23-2-.78-2,2,0,3.07,9.68,6.49,10.59,6.8a2,2,0,0,0-1.8,2.54c.37,2.47,14.86,5.68,25.64,4.63,9.11-.91,29.88-5.31,36.09-6.63l-1.64-29.13a72.57,72.57,0,0,1-11.55-1.35c-8.51-1.77-32.11-3.89-32.4-.46s15.6,8.14,14.31,9.45-13.75.58-19-.14S1648.14,913.86,1646,916.08Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1712.68,901.72l.51,8.81,1.64,29.13.44,7.73,112.94-1.87c13.11-.45,23.43-13,22.93-27.88s-11.71-26.67-24.86-26.21l-8.51,1.45,0,0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "1733.88 899.94 1787.79 895.41 1776.71 865.14"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 1785.8,
    y1: 946.22,
    x2: 1810.3,
    y2: 946.22
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1714.24,710.31c-1.67,3.37-1,7.14,1.62,8.41s6-.42,7.68-3.79,1-7.14-1.62-8.41S1715.91,706.94,1714.24,710.31Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1698.84,704.41c-1.68,3.37-.95,7.14,1.62,8.41s6-.42,7.68-3.79.94-7.14-1.62-8.41S1700.51,701,1698.84,704.41Z"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 1715.15,
    y1: 708.87,
    x2: 1708.91,
    y2: 706.72
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 252.45,
    y: 1438.16,
    width: 1715.14,
    height: 38.06,
    rx: 17.19
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "666.39 612.32 666.16 577.26 707.3 583.33 666.39 612.32"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M889,446l3.71-10.88s6.68-10.4,8.68-14.43c1.12-2.27,4.78-8.07,5.73-8.79.75-.56,2.92-.35,3.12.55.25,1.17-1.6,7.65-2.27,10.2l-2.56,9.7s14.06-12.77,18.52-17.31c2.51-2.56,9.53-10.34,11.42-8.71,1.44,1.24-4.85,10-7,13-2,2.78-7.74,11.16-7.74,11.16l13.07-13.6c2.38-2.47,8.54-10.73,10.71-9s-4.51,9.45-6.44,12.27l-10.92,15.9,14-13.91c1.94-1.92,7-8.41,8.88-6.62s-4,7.7-5.66,9.9l-11.69,15.06s7.8-7.33,10.39-9.78c1.11-1,4.52-4.05,5.51-2.93,1.35,1.52-2.94,5.93-4.22,7.56l-10.55,13.51a17.54,17.54,0,0,1-2.91,2.93l-17.87,17.94Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M750.3,571.49l139.25,88.18a39,39,0,1,1-41.29,64.82L687.74,640.35Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M913.33,701.05a39.73,39.73,0,0,0,.43-5.49,39,39,0,0,0-78,0l2.31,174.19H903Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M676.49,639.59l87.22,104.32a43.77,43.77,0,0,0,61.47,5.49h0a43.78,43.78,0,0,0,5.49-61.47L743.46,583.61A43.77,43.77,0,0,0,682,578.12h0A43.77,43.77,0,0,0,676.49,639.59Z"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "747.86 404.09 789.11 422.67 783.42 590.24 666.16 592.06 649.8 408.6 705.66 401.03 747.86 404.09"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M747.85,379.89v26.17s-1.57,5.65-14.87,5.71S705.66,403,705.66,403l4.11-57.22Z"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "747.86 402.47 720.68 374.26 747.86 373.9 747.86 402.47"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M759,327.25v36.84c0,7.44-2.09,18.46-10.45,21s-19.84-.93-27.85-9.62-25.78-48-1.07-62.52S758.41,323.41,759,327.25Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M814.94,556.6a23.31,23.31,0,0,0,29.65-.23h0L918,471.48l-10.08-10.62-18.53-19.58L887.21,439l-75.54,85A23.19,23.19,0,0,0,814.94,556.6Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M841,712.07a39,39,0,0,0-39-39c-21.54,0-33.37,9-38.07,30.47C753,753.41,730.12,886.25,730.12,886.25h67.59l42.85-168.69A39.73,39.73,0,0,0,841,712.07Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M842.07,557.66h0a27.06,27.06,0,0,1-36.77-10.15l-48.66-85.78A27,27,0,0,1,766.79,425h0a27,27,0,0,1,36.77,10.15l48.66,85.77A27.05,27.05,0,0,1,842.07,557.66Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M722.19,311.6s29.9-13.8,36.8-4.74-4.59,12.23-4.59,12.23,14.26-1.69,13.71,7.93-36.25-3.51-36.25-3.51,11.84,5.36,5,9.61-14.66-1.29-14.66-1.29-6.79,3.88-5.68,21.7S707,375.29,707,375.29s1.27-27-3.94-34.22S705.49,307.09,722.19,311.6Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M718.19,357.66c2.9,4.55,3.68,7.75.11,10a9.26,9.26,0,0,1-12.41-3c-2.9-4.55-2.36-10.08,1.21-12.36S715.29,353.12,718.19,357.66Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M708.87,357.31s3.67-.54,6.18,4.15a13.9,13.9,0,0,0-5.13,0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M736.76,348.13c0,1.72.91,3.12,2,3.12s2-1.4,2-3.12-.9-3.13-2-3.13S736.76,346.4,736.76,348.13Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M738.06,367.71s3,5.84,10.59,4.47"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M745.34,349.32l3.81,11a2.59,2.59,0,0,1-1,3l-3.1,2"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M733.58,342.94s4.26-3,8.31-1.08"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M757.62,348.13c0,1.72-.9,3.12-2,3.12s-2-1.4-2-3.12.91-3.13,2-3.13S757.62,346.4,757.62,348.13Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M759.5,342.77a6.44,6.44,0,0,0-7-.91"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M625.87,558.23h0a27,27,0,0,1-19.33-32.88l24.75-95.46a27.05,27.05,0,0,1,32.88-19.34h0a27.06,27.06,0,0,1,19.34,32.88l-24.76,95.46A27.05,27.05,0,0,1,625.87,558.23Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M590.06,632.21l-31.77-19.65-.07.11c-4.77,8.49-22.59,26.11-29.17,32.47a4.91,4.91,0,0,0-1.06,5.49l7.77,18a10.63,10.63,0,0,0,6.43,5.94l12.48,4.22a1.72,1.72,0,0,0,2.21-2l-2.55-10.16a3.09,3.09,0,0,1,1.75-3.56l12-5.42L558.05,673.7a2.14,2.14,0,0,0,.52,2.82l1.26.94a2.14,2.14,0,0,0,2.9-.27l21.66-25.29,5-18.84S589.64,632.77,590.06,632.21Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M740,359.51c-.53,1.59-3.51,2-6.66,1s-5.27-3.19-4.74-4.78,3.51-2,6.66-1S740.5,357.93,740,359.51Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M759,354.68v6.12c-2.58.3-4.69-.41-5-1.76C753.56,357.45,755.8,355.51,759,354.68Z"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "845.84 895.87 844.5 869.75 897.21 869.75 898.05 895.87 845.84 895.87"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "897.7 884.93 844.5 869.75 897.21 869.75 897.7 884.93"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "729.79 912.37 734.1 886.25 785.55 886.25 779.01 912.37 729.79 912.37"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "740.25 416.42 730.71 416.42 729.87 418.23 734.27 421.51 738.02 421.51 741.16 417.67 740.25 416.42"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "782.41 898.8 734.1 886.25 785.55 886.25 782.41 898.8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M648.28,503.52c-11.74-8.25-27.38-6.49-34.65,3.93L550.56,611l44.13,27.27,62.89-95.86C664.85,532,660.09,511.76,648.28,503.52Z"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "705.82 400.73 735.83 411.77 730.36 424.29 704.5 403.48 705.82 400.73"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "747.85 403.77 749.29 406.71 741.51 423.11 735.83 411.77 747.85 403.77"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "738.02 421.51 752.24 531.85 741.16 546.14 726.75 533.18 734.27 421.51 738.02 421.51"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 675.09,
    y1: 475.91,
    x2: 659.3,
    y2: 541.13
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 786.03,
    y1: 515.5,
    x2: 787.37,
    y2: 475.91
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M729.79,912.37l-4.63,19h69.06a15.57,15.57,0,0,0-15.17-19H729.79Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M845.84,895.87V916.6h72.32l-.08-1.71a20.07,20.07,0,0,0-20-19H845.84Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M899.08,900s1.58-6.89,5.47-5-5.22,5.27-5.22,5.27l5.41,3.74"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M899.08,900s-1.57-6.89-5.46-5,5.22,5.27,5.22,5.27L893.43,904"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M778.51,917.27s1.58-6.88,5.46-5-5.21,5.26-5.21,5.26l5.41,3.74"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M778.51,917.27s-1.57-6.88-5.46-5,5.22,5.26,5.22,5.26l-5.41,3.74"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot01);
export default __webpack_public_path__ + "static/media/iot-01.e9845b26db415ff5edcbb4285b8eb114.svg";
export { ForwardRef as ReactComponent };